import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import imageDefault from "images/devices/default-device.png";
import imageBloom from "images/devices/bloom-promotion.png";
import imageChorus from "images/devices/chorus-promotion.png";
import imageDitto from "images/devices/ditto-promotion.png";
import imageGala from "images/devices/gala-promotion.png";
import imageJive from "images/devices/jive-promotion.png";
import imageMelt from "images/devices/melt-promotion.png";
import imageMoxie from "images/devices/moxie-promotion.png";
import imageNova from "images/devices/nova-promotion.png";
import imageNova2 from "images/devices/nova2-promotion.png";
import imagePivot from "images/devices/pivot-promotion.png";
import imageRave from "images/devices/rave-promotion.png";
import imageSync from "images/devices/sync-promotion.png";
import imageVector from "images/devices/vector-promotion.png";
import imageVerge from "images/devices/verge-promotion.png";
import imageWand from "images/devices/wand-promotion.png";
import imageWish from "images/devices/wish-promotion.png";

const serviceUuid = "f000bb03-0451-4000-b000-000000000000";
const characteristicUuid = "f000c000-0451-4000-b000-000000000000";

const devices = [
  { name: "Classic", image: imageDefault },
  { name: "Nova", image: imageNova },
  { name: "Rave", image: imageRave },
  { name: "Cougar", image: imageDefault },
  { name: "4 Plus", image: imageDefault },
  { name: "Sync", image: imageSync },
  { name: "Pivot", image: imagePivot },
  { name: "Verge", image: imageVerge },
  { name: "Wish", image: imageWish },
  { name: "Gala", image: imageGala },
  { name: "Jive", image: imageJive },
  { name: "Ditto", image: imageDitto },
  { name: "Bloom", image: imageBloom },
  { name: "Vector", image: imageVector },
  { name: "Moxie", image: imageMoxie },
  { name: "Melt", image: imageMelt },
  { name: "Wand", image: imageWand },
  { name: "Chorus", image: imageChorus },
  { name: "Nova 2", image: imageNova2 },
];

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class WeVibe extends BaseDeviceWrapper {
  constructor(device, isSendingData) {
    const deviceRec = devices.find((d) => d.name === device.name);
    if (!deviceRec) {
      throw Error(`Device ${device.name} is not supported`);
    }
    const { image } = deviceRec;
    super(device, serviceUuid, characteristicUuid, image, isSendingData);
  }

  static get deviceNames() {
    return devices.map((d) => d.name);
  }

  /**
   * Needed to request access to these services before connecting to the device
   */
  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "We-Vibe";
  }

  async write(percent) {
    const value = Math.max(0, Math.min(100, Math.round(percent)));
    const array = new Uint8Array([
      0x0f,
      value ? 0x03 : 0x00,
      Math.floor((value / 100) * 0x0f),
      0,
      0,
      0,
      0,
      0,
    ]);
    await this.motorChar.writeValueWithResponse(array);
  }
}
